import { createContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { API_URL } from '../services/api';
import { RedirectTo } from '../utils/redirectTo';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);

  const history = useHistory();

  // Login user
  const login = async (body) => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const response = await res.json();
      const data = response.data;

      // console.log(response);
      // console.log(data);

      if (!res.ok) {
        setError(response.message);
        setError(null);
        setLoading(false);
      }

      if (res.ok) {
        if (data.accountActivated === false) {
          setLoading(false);
          setError('Usuário não ativado! Ative sua conta a seguir.');
          history.push(RedirectTo.activate);
          return;
        }

        if (!['user', 'pdv'].includes(data.profile)) {
          setLoading(false);
          setError(
            'Acesso permitido apenas para usuários e PDV.',
          );
          return;
        }

        setUser(data.data);

        localStorage.setItem('name', data.name);
        localStorage.setItem('shortName', data.shortName);
        localStorage.setItem('id', data.id);
        localStorage.setItem('cpfCnpj', data.cpfCnpj);
        localStorage.setItem('birthDay', data.birthDay);
        localStorage.setItem('email', data.email);
        localStorage.setItem('phone', data.phone);
        localStorage.setItem('token', data.token);
        localStorage.setItem('profile', data.profile);
        localStorage.setItem('profile2', data.profile2);
        localStorage.setItem('discount', data.discount);

        sessionStorage.setItem('token', data.token);

        setLoading(false);
        history.push(RedirectTo.dashboard);
      }
    } catch (e) {
      setLoading(false);
      setError(e.message);
      setError(null);
    } finally {
      setLoading(false);
      setError(null);
    }
  };

  // Logout user
  const logout = async () => {
    setUser(null);
    setError(null);
    localStorage.removeItem('name');
    localStorage.removeItem('shortName');
    localStorage.removeItem('id');
    localStorage.removeItem('cpfCnpj');
    localStorage.removeItem('birthDay');
    localStorage.removeItem('email');
    localStorage.removeItem('phone');
    localStorage.removeItem('token');
    localStorage.removeItem('profile');
    localStorage.removeItem('profile2');
    localStorage.removeItem('discount');
    localStorage.removeItem('dashboardRefresh');

    sessionStorage.removeItem('licensePlate');

    history.push(RedirectTo.login);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        error,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
